import { useQuery } from '@tanstack/react-query';
import { checkGroupChatMember } from '~/api';
import { CheckGroupChatMemberRequest } from '~/types';
import chatRoomKey from './chatRoomKey';

const useGroupChatCheckMemberQuery = (request: CheckGroupChatMemberRequest) => {
  return useQuery({
    queryKey: chatRoomKey.groupChatCheckMember(request),
    queryFn: () => checkGroupChatMember(request),
    enabled: !!request.chatroom_id,
    refetchOnMount: true,
    staleTime: 0,
    retry: 1,
  });
};

export default useGroupChatCheckMemberQuery;
